import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ReactFC from 'react-fusioncharts';
import { Algorithm } from '../../helper';
//@ts-ignore
FusionCharts.options['license']({key:Algorithm.getHexDecryptionKey(localStorage.getItem('chartKey') ? localStorage.getItem('chartKey'):""),creditLabel: false});  
ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

export { FusionCharts, ReactFC };